import { Box, Typography, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'

const SistemaGalateaPage: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
      <Paper
        elevation={2}
        sx={{ maxWidth: 720, width: '100%', p: 4, textAlign: 'center' }}
      >
        <Typography variant="body1" color="text.secondary">
          {t('config.sistemaGalatea.subtitle')}
        </Typography>
      </Paper>
    </Box>
  )
}

export default SistemaGalateaPage


